import api from "@/services/utils/apiInstance.ts";

import type { Collaborator } from "@/types/services/auth.type.ts";
import type {
  CollaboratorListFilters,
  CollaboratorListResponse,
  CollaboratorUpdatePayload,
} from "@/types/services/collaborator.type.ts";

class CollaboratorService {
  async getPaginatedAccountCollaboratorsList(
    search: string,
    sort: string,
    order: string,
    page: number,
    limit: number,
    filters: CollaboratorListFilters = {},
    signal: AbortSignal | undefined = undefined,
  ): Promise<CollaboratorListResponse> {
    const encodedFilters: string = Object.keys(filters).length
      ? encodeURIComponent(JSON.stringify(filters))
      : "";
    const url = `/account/collaborators/list?search=${encodeURIComponent(search)}&sort=${sort}&order=${order}&page=${page}&limit=${limit}&filters=${encodedFilters}`;
    const response = await api.get<CollaboratorListResponse>(url, { signal });
    return response.data;
  }

  async getCollaborator(
    collaboratorId: number | string,
  ): Promise<Collaborator> {
    const response = await api.get<Collaborator>(
      `/account/collaborator/${collaboratorId}`,
    );
    return response.data;
  }

  async updateCollaborator(
    payload: CollaboratorUpdatePayload,
  ): Promise<Collaborator> {
    const response = await api.put<Collaborator>(
      "/account/collaborator",
      payload,
    );
    return response.data;
  }

  async switchCollaborator(collaboratorId: number): Promise<void> {
    await api.post(`/account/collaborator/switch/${collaboratorId}`);
  }
}

export default new CollaboratorService();
